import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  DataGridTable,
  Loader,
  useAuthInfo,
  ApprovalButtons,
  checkKnownDateOrString,
  ApproverHistoryDisplay,
  useApproverHistoryList,
} from "../../common";
import {
  SampleRequestApprovalProcurementEditItemModal,
  SampleRequestApprovalProcurementAddItemModal,
  SampleRequestApprovalProcurementAddSupplierModal,
  setPageDetails,
  onRowsSelectionHandler,
  handleProcurementApproval,
  SampleRequestApprovalProcurementMarkItemInactiveModal,
} from "./";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import _ from "lodash";

export function SampleRequestApprovalProcurement() {
  const { id } = useParams();
  const decoded = useAuthInfo();
  const { approverHistoryList, isApproverHistoryListLoading } =
    useApproverHistoryList(id);
  const [addButton, setAddButton] = useState();
  const [value, setValue] = useState({ comments: "" });
  const [errors, setErrors] = useState();
  const [detailsData, setDetailsData] = useState();
  const [itemList, setItemList] = useState();
  const [statuses, setStatuses] = useState();
  const [pageDescription, setPageDescription] = useState();
  const [itemFormToEdit, setItemFormToEdit] = useState();
  const [selectedRowsData, setSelectedRowsData] = useState();
  const [supplierButtonDisabled, setSupplierButtonDisabled] = useState(true);
  const [maxSuppliers, setMaxSuppliers] = useState();
  const history = useNavigate();

  //state for editItem, markItemInactive and addItem modals
  const [openEditItemSampleRequestModal, setOpenEditItemSampleRequestModal] =
    useState(false);
  const [
    openMarkItemInactiveSampleRequestModal,
    setOpenMarkItemInactiveSampleRequestModal,
  ] = useState(false);
  const [openAddItemSampleRequestModal, setOpenAddItemSampleRequestModal] =
    useState(false);
  const [
    openAddSupplierSampleRequestModal,
    setOpenAddSupplierSampleRequestModal,
  ] = useState(false);
  //handler functions for editItem, markItemInactive and addItem modals
  const handleOpenEditItemSampleRequestModal = () => {
    setOpenEditItemSampleRequestModal(true);
  };
  const handleOpenMarkItemInactiveSampleRequestModal = () => {
    setOpenMarkItemInactiveSampleRequestModal(true);
  };
  const handleOpenAddItemSampleRequestModal = () => {
    setOpenAddItemSampleRequestModal(true);
  };
  const handleOpenAddSupplierSampleRequestModal = () => {
    setOpenAddSupplierSampleRequestModal(true);
  };

  //append EditorDelete button to each item in the itemList if procurement approval is pending
  statuses &&
    itemList &&
    statuses.procurementApproval.status === "pending" &&
    itemList.forEach((item) => {
      item.editItem = "Edit Item";
      item.markInactive = "Mark Inactive";
    });

  // append MarkInactive button to each item in the itemList if procurement approval is Accepted
  statuses &&
    itemList &&
    statuses.procurementApproval.status === "Accepted" &&
    itemList.forEach((item) => {
      const supplierList = item.supplierList;
      const allSuppliersPending =
        supplierList.length === 0 ||
        supplierList.every((supplier) => supplier.receiptDate === "pending");

      if (allSuppliersPending && item.isActive !== false) {
        item.markInactive = "Mark Inactive";
      } else {
        item.markInactive = " ";
      }
    });

  const handleOnCellClick = (params) => {
    params.field === "editItem" && handleOpenEditItemSampleRequestModal();
    params.value === "Mark Inactive" &&
      handleOpenMarkItemInactiveSampleRequestModal();
    //set the row clicked on as setItemFormToEdit
    setItemFormToEdit(params.row);
  };

  //handler function for accepted/rejected comments textfield
  const handleChange = (event) => {
    setValue({ comments: event.target.value });
  };
  useEffect(() => {
    setPageDetails(
      id,
      setAddButton,
      handleOpenAddItemSampleRequestModal,
      handleOpenAddSupplierSampleRequestModal,
      setPageDescription,
      setItemList,
      setDetailsData,
      setStatuses,
      setErrors,
      supplierButtonDisabled,
      history,
    );
    // eslint-disable-next-line no-console
  }, [id, supplierButtonDisabled]);

  errors && console.log({ errors });

  return detailsData ? (
    <>
      <Grid
        container
        justifyContent="center"
        rowSpacing={4}
        columnSpacing={2}
        sx={{
          paddingBottom: 4,
          maxWidth: "100vw",
        }}
      >
        <Grid item xs={12}>
          <div className="card">
            <div
              className="card__text"
              style={{
                padding: "20px 20px",

                overflowWrap: "break-word",
              }}
            >
              <Grid item xs={12} mb={3}>
                <Typography component="h1" variant="h5" gutterBottom>
                  <b> {pageDescription?.title}</b>
                </Typography>
                <Typography component="h1" variant="h6">
                  The list of items in the sample request is given below.{" "}
                  {pageDescription?.subTitle}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom>
                  <b>Sample Request Details</b>
                </Typography>
              </Grid>

              <Grid container columnSpacing={1}>
                {Object.keys(detailsData).map((oneKey, i) => {
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={2} key={oneKey}>
                      <Grid item>
                        <Typography
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {_.startCase(Object.keys(detailsData)[i]) + ":"}
                          <ApproverHistoryDisplay
                            item={Object.keys(detailsData)[i]}
                            data={approverHistoryList}
                            isLoading={isApproverHistoryListLoading}
                          />
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="h6"
                          sx={{
                            mb: 1.5,
                            color: "black",
                          }}
                        >
                          {checkKnownDateOrString(oneKey, detailsData[oneKey])}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
                {statuses.procurementApproval.status === "pending" && (
                  <ApprovalButtons
                    value={value}
                    errors={errors}
                    handleChange={handleChange}
                    handleApproval={handleProcurementApproval(
                      setErrors,
                      id,
                      decoded,
                      history,
                    )}
                    requestResubmission={true}
                  />
                )}
              </Grid>

              <Typography
                sx={{ mt: 3 }}
                component="h1"
                variant="h5"
                gutterBottom
              >
                Procurement Approval
              </Typography>
              <Grid container columnSpacing={1}>
                {Object.keys(statuses.procurementApproval).map((oneKey, i) => {
                  return (
                    <Grid item xs={12} sm={6} md={4} lg={2} key={oneKey}>
                      <Grid item>
                        <Typography>
                          {_.startCase(
                            Object.keys(statuses.procurementApproval)[i],
                          ) + ":"}
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography
                          variant="h6"
                          sx={{
                            mb: 1.5,
                            color: "black",
                          }}
                        >
                          {checkKnownDateOrString(
                            oneKey,
                            statuses.procurementApproval[oneKey],
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </div>
        </Grid>

        <Grid item xs={12}>
          {itemList && (
            <DataGridTable
              title="Sample Request Item List"
              description="Click on a row to view item details"
              data={itemList}
              detailsBool={true}
              checkBoxBool={
                statuses.procurementApproval.status === "Accepted" && true
              }
              onRowsSelectionHandler={onRowsSelectionHandler(
                itemList,
                setSelectedRowsData,
                setSupplierButtonDisabled,
                setMaxSuppliers,
              )}
              onCellClick={handleOnCellClick}
              button={addButton}
              isRowSelectable={"supplierList"}
            />
          )}
        </Grid>
      </Grid>

      {itemFormToEdit && (
        <>
          <SampleRequestApprovalProcurementEditItemModal
            open={openEditItemSampleRequestModal}
            setOpen={setOpenEditItemSampleRequestModal}
            handleOpen={handleOpenEditItemSampleRequestModal}
            data={itemFormToEdit}
            itemList={itemList}
            detailsData={detailsData}
          />
          <SampleRequestApprovalProcurementMarkItemInactiveModal
            open={openMarkItemInactiveSampleRequestModal}
            setOpen={setOpenMarkItemInactiveSampleRequestModal}
            handleOpen={handleOpenMarkItemInactiveSampleRequestModal}
            data={itemFormToEdit}
            itemList={itemList}
            detailsData={detailsData}
          />
        </>
      )}
      <SampleRequestApprovalProcurementAddItemModal
        open={openAddItemSampleRequestModal}
        setOpen={setOpenAddItemSampleRequestModal}
        handleOpen={handleOpenAddItemSampleRequestModal}
        detailsData={detailsData}
        itemList={itemList}
      />
      <SampleRequestApprovalProcurementAddSupplierModal
        open={openAddSupplierSampleRequestModal}
        setOpen={setOpenAddSupplierSampleRequestModal}
        handleOpen={handleOpenAddSupplierSampleRequestModal}
        detailsData={detailsData}
        selectedRowsData={selectedRowsData}
        itemList={itemList}
        maxSuppliers={maxSuppliers}
      />
    </>
  ) : errors?.norequest ? (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      marginTop="170px"
      direction="column"
    >
      <p>
        There is no sample request for this <b>Sample Request ID</b>;
      </p>
      <p>
        Please make sure that the <b>Sample Request ID</b> is correct in the
        link you're trying to access.
      </p>
    </Grid>
  ) : (
    <Grid container justifyContent="center" marginTop="170px">
      <Loader />
    </Grid>
  );
}
